import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { LoginInterface } from '../login.interface';

@Component({
  selector: 'ltg-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.css']
})
export class LoginFormComponent implements OnInit {

  form: FormGroup;
  @Output() login = new EventEmitter<LoginInterface>();

  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.form = this.fb.group({
      email: ['', [ Validators.required, Validators.email ] ],
      password: ['', Validators.required ],
    });
  }

  onSubmit() {
    const value = this.form.value;
    const loginValues = { email: value.email, password: value.password };
    this.login.emit(loginValues);
  }

}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/auth/login/login-form/login-form.component.ts